import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {HOTO_SITE, HOTO_ENG_SITE, HOTO_MATERIAL_LIST, HOTO_DETAILS, HOTO_ALL_DETAILS} from './type';

export const fetchHotoSites = (team = null, listType = null, page = 1, filterData = null) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null? `${Config.maintenance.fetchHotoList}?page=${page}&team=${team}&listType=${listType}`: `${Config.maintenance.fetchHotoList}?site_no=${filterData.site_no}&client_name=${filterData.client_name}&site_type=${filterData.site_type}&assignee_id=${filterData.assignee_ids}&commercial_type_id=${filterData.commercial_type_id}&page=${page}&team=${team}&listType=${listType}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: HOTO_SITE,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchHotoEngList = (team = null, page = 1, filterData = null) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null? `${Config.maintenance.fetchHotoEngList}?page=${page}&team=${team}`: `${Config.maintenance.fetchHotoEngList}?site_no=${filterData.site_no}&client_name=${filterData.client_name}&site_type=${filterData.site_type}&assignee_id=${filterData.assignee_ids}&commercial_type_id=${filterData.commercial_type_id}&page=${page}&team=${team}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: HOTO_ENG_SITE,
      payload: data.response.data,
    });
    return true;
  }
};

export const getHotoMaterialList = (team, hotoId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.getHotoMaterialList}?team=${team}&hoto_id=${hotoId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: HOTO_MATERIAL_LIST,
      payload: data.response.data,
    });
    return true;
  }
};

export const saveHotoMaintenance = (data) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.saveHotoMaintenance}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const getHotoDetails = (hotoId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.getHotoDetails}?hoto_id=${hotoId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: HOTO_DETAILS,
      payload: data.response.data,
    });
    return true;
  }
};

export const updateHotoStatus = (data) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.updateHotoStatus}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const storeHotoInstallation = (data) => async (
  dispatch
) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.storeHotoInstallation}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const getAllHotoDetails = (siteId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.getAllHotoDetails}?site_id=${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: HOTO_ALL_DETAILS,
      payload: data.response.data,
    });
    return true;
  }
};